import Button from "../../../componentsNew/Button";
import { CampoInputBase } from "../../../componentsNew/Input/CampoInput/CampoInputBase";
import Typography from "../../../componentsNew/Typography";
import star from "../../../assets/img/stars-02.svg"
import Card from "../../../componentsNew/Card";
import { LinkReferencia } from "../components/LinkReferencia";
import CircularProgress from "../../../componentsNew/CircularProgress";
import { useEffect, useState } from "@wordpress/element";
import { ObterReferencias } from "../../../api/controllers/optiGenerator";
import { toast } from "react-toastify";
import { CustomWarning } from "@componentsNew/CustomWarning";
import { alert } from "@componentsNew/CustomWarning/types";

export function StepReferencia({  setErroNext,form, mudarValor, tema, descricao, keyword }) {

    const [referencias, setReferencias] = useState([])
    const [loading, setLoading] = useState(false)
    const [link, setLink] = useState("")
    const [custoId, setCustoId] = useState(0)
    const [errorIa, setErrorIA] = useState(false)
    const [errorIaTexto, setErrorIaTexto] = useState("")

    useEffect(() => {
        setLoading(true)

        ObterReferencias(tema, descricao, keyword).then(({ data }) => {
            if (data['erro'] == "NaoApropriado") {
                setErrorIaTexto("Não utilize termos inapropriados, tente novamente com outro tema.")
                setErrorIA(true)
            } else {
                setErroNext(false)
                setReferencias(data.results)
                setLoading(false)
                setCustoId(data.custoArtigoIaId)
                mudarValor("linksReferencia", data.results);
            }
        }).catch(() => {
            setErrorIaTexto("Houve um erro inesperado ao tentar buscar as referências, tente novamente mais tarde.")
            setErrorIA(true)
        });
    }, [tema != ""])

    useEffect(() => {
        if (custoId != 0) {
            mudarValor("custoArtigoIaId", custoId)
        }
    }, [custoId])

    useEffect(() =>{
        setErroNext(true)
    },[])

    function removerReferencia(position) {
        const newReferencias = referencias
            .filter(referencia => referencia.position != position)
            .map((referencia, index) => ({
                ...referencia,
                position: index + 1
            }));

        setReferencias(newReferencias);
        mudarValor("linksReferencia", newReferencias);
    }

    function inserirLink() {
        try {
            new URL(link);

            var referencia = {
                description: link,
                position: referencias.length + 1,
                thumbnail: "",
                title: `Referência adicionada pelo usuário`,
                url: link
            }

            setReferencias([...referencias, referencia]);
            mudarValor("linksReferencia", [...referencias, referencia]);
        } catch (e) {
            toast.error("Insira uma URL válida", {
                toastId: "url_invalid",
            });
            return;
        }
    }

    return (
        <>
            <Card className="px-4 py-3 text-center !shadow-[0px_5px_4px_0px_rgba(0,0,0,0.20)]">
                <Typography component="body-secundary-bold">Selecionamos os 3 melhores artigos no ranque do Google de acordo com o tema sugerido pelo usuário ou gerado pela nossa IA</Typography>
            </Card>

            <CampoInputBase
                className={"mt-8"}
                label="Inserir link de referência"
                placeholder="Insira seu link..."
                valor={link}
                setValor={e => setLink(e)}
            />
            <div className="flex justify-between w-full">
                <Button disabled={referencias?.length == 3} onClick={() => inserirLink()} className="w-3/5 mt-8 mr-2"><Typography component="button">Inserir Link</Typography></Button>
            </div>

            <hr className="mt-8" />
            <p className="text-gray-600 text-lg font-semibold">Link(s) a ser utilizado como referência - {referencias && referencias.length == 0 ? 0 : referencias.length}/3 (Limite de referências)</p>

            <div>
                {errorIa && <CustomWarning
                    alertType={alert.error}
                    content={
                        <Typography className="font-[0.75rem] mt-4">
                            {errorIaTexto}
                        </Typography>
                    } />}

                {loading && !errorIa && <>
                    <div className="flex flex-col items-center">
                        <CircularProgress className="mt-8" />
                        <p className="text-center mt-4">Estamos buscando as referências do seu tema...</p>
                    </div>
                </>}
                {!loading && referencias && referencias.map(referencia => <LinkReferencia remover={removerReferencia} thumb={referencia.thumbnail} position={referencia.position} title={referencia.title} url={referencia.url} description={referencia.description} />)}
                {!loading && referencias.length == 0 && <>
                    <div className="flex flex-col items-center">
                        <p className="text-center mt-4">Insira pelo menos uma referência</p>
                    </div>
                </>}
            </div>

        </>
    )
}